module.exports = __webpack_public_path__ + "img/75591.1cd6deb8.svg";